import React, { createContext, useContext } from "react";

import Modal from "../components/modal/Modal";
import Portal from "../components/Portal/Portal";

import { EL_ID_PORTAL_MAIN_AFTER } from "../components/Portal/PortalMainAfter/constants";

const ModalContext = createContext({});

class ModalProvider extends React.Component {
  state = {
    stack: null,
  }
  
  setStack = (valueNew) => {
    this.setState((s) => ({
      ...s,
      stack: typeof valueNew === "function" ? valueNew(s.stack) : valueNew,
    }));
  }
  
  clearStack = () => {
    this.setStack(null);
  };

  pushToStack = (item) => {
    this.setStack((valueOld) => valueOld ? [...valueOld, item] : [item]);
  };

  showModal = (modalContent, options)=> {
    this.pushToStack({
      ...options,
      component: modalContent,
      dialogId: options?.dialogId || Math.random(),
    });
  };

  showDialog = (
    title,
    message,
    onConfirm,
    options,
  ) => {
    this.pushToStack({
      ...options,
      title,
      message,
      onConfirm,
      dialogId: options?.dialogId || Math.random(),
    });
  };

  showConfirm = (title, message, onConfirm, options)=> {
    this.pushToStack({
      ...options,
      confirm: true,
      title,
      message,
      onConfirm,
      dialogId: options?.dialogId || Math.random(),
    });
  };

  onClose = (dialogId) => {
    this.setStack((stackOld) => {
      if (stackOld) {
        const itemToClose = dialogId && typeof dialogId === 'number'
          ? stackOld.find((m) => m.dialogId === dialogId)
          : stackOld[stackOld.length - 1];

        if (itemToClose?.onClose) {
          itemToClose.onClose();
        }

        return stackOld.filter((i) => i !== itemToClose);
      }

      return null;
    });
  };

  checkDialogId = (dialogId)=> {
    return this.state.stack ? this.state.stack.some((i) => i.dialogId === dialogId) : false;
  };

  render() {
    return (
      <ModalContext.Provider value={{
        checkDialogId: this.checkDialogId,

        showModal: this.showModal,
        showDialog: this.showDialog,
        hideDialog: this.onClose,

        showConfirm: this.showConfirm,

        onClose: this.onClose, // back-compatibility for Lite App
        clearStack: this.clearStack,
      }}>
        {this.props.children}

        <Portal id={EL_ID_PORTAL_MAIN_AFTER}>
          {
            this.state.stack ? this.state.stack.map((props, index) => {
              return (
                <Modal key={props.dialogId ?? index} props={props} onClose={this.onClose} />
              );
            }) : null
          }
        </Portal>
      </ModalContext.Provider>
    );
  }
}


/**
 *
 * @returns {{
 *   checkDialogId: function,
 * showModal: function,
 * showDialog: function,
 * hideDialog: function,
 * showConfirm: function,
 * onClose: function,
 * clearStack: function,
 * }}
 */
export const useModalContext = () => useContext(ModalContext);

export default ModalProvider;
